import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=4fa67a52&scoped=true"
import script from "./RoleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=4fa67a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa67a52",
  null
  
)

export default component.exports